'use strict';

// const { contains } = require("cheerio");

document.addEventListener('DOMContentLoaded', function () {

  /**
   * パラメータ取得関数
   * URLのクエリ文字列から指定されたパラメータ名に対応する値を取得します。
   * @param {string} name 取得したいパラメータ名
   * @param {string} url 別ページのURLを使用したい場合
   * @returns {string|null} パラメータの値、またはパラメータが存在しない場合はnull
   */
  function getParam(name, url = window.location.search) {
    const params = new URLSearchParams(url);
    const value = params.get(name);
    return value ? sanitizeUrl(value) : null;
  }


  /**
   * エスケープ関数
   * HTMLエスケープ処理を行うための関数です。
   * @param {string} input エスケープしたい文字列
   * @returns {string} エスケープ処理後の文字列
   */
  function sanitizeUrl(input) {
    if (typeof input !== 'string') {
      throw new TypeError('Expected a string');
    }
    return input.replace(/[&'"<>]/g, function (match) {
      return {
        '&': '&amp;',
        "'": '&#x27;',
        '"': '&quot;',
        '<': '&lt;',
        '>': '&gt;',
      }[match];
    });
  }

  // ----------------------------------------
  //  スライダー
  // ----------------------------------------

  if (document.querySelector('.top .js-slider')) {
    const jsSlider = new Splide('.js-slider', {
      type: 'loop',
      perPage: 6,
      gap: '20px',
      breakpoints: {
        780: {
          perPage: 3, // 780px以下は3枚
          gap: 'calc(10 / 390 * 100vw)',
        },
      },
      // 連続移動に不要な UI はオフ
      arrows: false,
      pagination: false,
      drag: false,
      // “カクつき”回避：トランジションのイージングは linear に
      speed: 800,
      easing: 'linear',
      // オートプレイは使わない（AutoScroll が動かす）
      autoplay: false,
      // 連続移動中のクラス更新（任意）
      updateOnMove: true,

      autoScroll: {
        // 速度。数値を上げるほど速く流れます（負にすると右方向へ）
        speed: 1.2,
        // ホバーやフォーカスで止めない
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    });

    // 拡張を有効化してマウント
    jsSlider.mount(window.splide.Extensions);

    const playBtn = document.querySelector('.playBtn');
    const pauseBtn = document.querySelector('.pauseBtn');

    // 停止
    pauseBtn.addEventListener('click', () => {
      console.log('pause clicked');
      jsSlider.Components.AutoScroll.pause();

      playBtn.disabled = false;
      pauseBtn.disabled = true;

      playBtn.querySelector('img').src = "/info/monozukurikids/_/images/icon_play.svg";
      pauseBtn.querySelector('img').src = "/info/monozukurikids/_/images/icon_stop-playing_2.svg";
    });

    // 再生
    playBtn.addEventListener('click', () => {
      console.log('play clicked');
      jsSlider.Components.AutoScroll.play();

      playBtn.disabled = true;
      pauseBtn.disabled = false;

      playBtn.querySelector('img').src = "/info/monozukurikids/_/images/icon_play_2.svg";
      pauseBtn.querySelector('img').src = "/info/monozukurikids/_/images/icon_stop-playing.svg";
    });




  }

  if (document.querySelector('.nazenani .js-slider')) {
    const jsSlider = new Splide('.js-slider', {
      type: 'fade',
      rewind: true,     // 末尾→先頭にスムーズに戻す
      perPage: 1,
      arrows: false,
      pagination: false,
      drag: false,
      speed: 1500,
      // 自動再生（Auto Scroll ではなく Autoplay を使う）
      autoplay: true,
      interval: 4700,
      pauseOnHover: false,
      updateOnMove: true,
    });

    jsSlider.on('mounted', () => {
      // autoplay を一旦止める
      jsSlider.Components.Autoplay.pause();

      // 最初だけ 2000ms
      setTimeout(() => {
        jsSlider.go('>');
        jsSlider.Components.Autoplay.play(); // ここで通常の autoplay 再開
      }, 2000); // ← 最初だけ早めたい時間
    });

    jsSlider.mount();


    const playBtn = document.querySelector('.playBtn');
    const pauseBtn = document.querySelector('.pauseBtn');

    // 停止
    pauseBtn.addEventListener('click', () => {
      jsSlider.Components.Autoplay.pause();

      playBtn.disabled = false;
      pauseBtn.disabled = true;

      playBtn.querySelector('img').src = "/info/monozukurikids/_/images/icon_play.svg";
      pauseBtn.querySelector('img').src = "/info/monozukurikids/_/images/icon_stop-playing_2.svg";
    });

    // 再生
    playBtn.addEventListener('click', () => {
      jsSlider.Components.Autoplay.play();

      playBtn.disabled = true;
      pauseBtn.disabled = false;

      playBtn.querySelector('img').src = "/info/monozukurikids/_/images/icon_play_2.svg";
      pauseBtn.querySelector('img').src = "/info/monozukurikids/_/images/icon_stop-playing.svg";
    });

  }

  // ----------------------------------------
  //  ヘッダーの高さを測定＆高さ確保
  // ----------------------------------------

  function addFVPadding() {
    const headerHeight = $('.header').outerHeight();
    $('.l-main').css('padding-top', `${headerHeight}px`);
    $('#js-nav-body').css('top', `${headerHeight}px`);
  }

  addFVPadding();

  $(window).on('resize', addFVPadding);


  // ----------------------------------------
  //  Slide Toggle
  // ----------------------------------------

  const toggleTrigger = $('.js-slideToggleTrigger');
  const toggleBody = $('.js-slideToggle');
  const toggeleImg = $('.js-icon-arrow-down');

  if ($(toggleTrigger).length) {

    toggleTrigger.on('click', function () {
      $(this).next(toggleBody).slideToggle(300);

      if ($(this).find(toggeleImg).length) {
        $(this).find(toggeleImg).toggleClass('active');
      }

    });
  }

  if ($(toggleTrigger).length) {


    const toggleTrigger = $('.js-slideToggleTrigger');

    toggleTrigger.on('click', function () {
      const $btn = $(this);

      // 1) 直前の兄弟（<p class="js-slideToggle">）だけを対象に
      const $body = $btn.prev('.js-slideToggle');
      $body.toggleClass('active');

      // 2) aria/アイコン
      const isTrue = $btn.attr('aria-expanded');
      if (isTrue === 'true') {
        $btn.attr('aria-expanded', 'false');
      } else {
        $btn.attr('aria-expanded', 'true');
      }
    });

  }

  const karakuriTxt = document.querySelector('.js-karakuri-part_txt_body')
  const karakuriTopTrigger = document.querySelector('.js-txtToggleTrigger--karakuri-top')

  if ($(karakuriTopTrigger).length) {
    $(karakuriTopTrigger).on('click', function () {
      const $btn = $(this);

      const isTrue = $btn.attr('aria-expanded');
      if (isTrue === 'true') {
        $btn.attr('aria-expanded', 'false');
      } else {
        $btn.attr('aria-expanded', 'true');
      }

      $(karakuriTxt).toggleClass('active');

      const toggeleImg = $('.js-icon-arrow-down-karakuri');
      if ($(karakuriTopTrigger).find(toggeleImg).length) {
        $(karakuriTopTrigger).find(toggeleImg).toggleClass('active');
      }
    });
  }


  // ----------------------------------------
  //  Hambuger menu
  // ----------------------------------------

  const hambuger = $('#js-hamburger');
  const navBody = $('#js-nav-body');

  hambuger.on('click', function () {
    $(this).toggleClass('active');
    $(navBody).toggleClass('active');
    $('body').toggleClass('modal-open');
    $('html').toggleClass('modal-open');
    const isTrue = $(this).attr('aria-expanded');
    if (isTrue === 'true') {
      $(this).attr('aria-expanded', 'false');
    } else {
      $(this).attr('aria-expanded', 'true');
    }
  });

  $('.l-header_inner_bg').on('click', function () {
    $(hambuger).toggleClass('active');
    $(navBody).toggleClass('active');
    $('body').toggleClass('modal-open');
    $('html').toggleClass('modal-open')
    $(hambuger).attr('aria-expanded', 'false');
  });

  // ----------------------------------------
  //  Hambuger menu: Focus Loop & ESC to Close
  // ----------------------------------------

  const header = document.getElementsByClassName('l-header')[0];
  const hamburguerBtn = document.getElementById('js-hamburger');
  const focusableElementsSelector = 'l-header a[href], header a[href], .l-header button:not([disabled]), .l-header_nav a[href], .l-header_nav area[href], .l-header_nav button:not([disabled])';


  header.addEventListener('keydown', function (e) {
    if (hamburguerBtn.classList.contains('active')) {

      if (e.key === 'Tab') {
        e.preventDefault();
        const focusableElements = Array.from(
          header.querySelectorAll(focusableElementsSelector)
        );
        const focusableItemIndex = focusableElements.indexOf(document.activeElement);

        if (e.shiftKey) {
          if (focusableItemIndex === 0) {
            focusableElements[focusableElements.length - 1].focus();
          } else {
            focusableElements[focusableItemIndex - 1].focus();
          }
        } else {
          if (focusableItemIndex === focusableElements.length - 1) {
            focusableElements[0].focus();
          } else {
            focusableElements[focusableItemIndex + 1].focus();
          }
        }
      }
    };
  });


  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      document.querySelector('.l-header_inner')?.classList.remove('active');
      document.querySelector('html').classList.remove('modal-open');
      document.querySelector('body').classList.remove('modal-open');
      hamburguerBtn?.classList.remove('active');
      hamburguerBtn.setAttribute('aria-expanded', false);
    }
  });


  // ----------------------------------------
  //  Modal
  // ----------------------------------------

  const modalTrigger = $('.js-OpenModalTrigger');
  const modalBody = $('.js-OpenModal');
  const modal = $('.m_modal');
  let lastFocusedEl = null;

  const DATA_KEYS = ['program', 'karakuri', 'purpose'];

  if ($(modalTrigger).length) {

    modalTrigger.on('click', function (e) {

      e.preventDefault();

      const $trigger = $(this);

      const key = DATA_KEYS.find(k => $trigger.is(`[data-${k}]`));

      if (!key) {
        return;
      }

      const val = $trigger.attr(`data-${key}`) || $trigger.data(key);

      if (!val) {
        return;
      }

      const $modal = modal.filter(`[data-${key}="${val}"]`);
      const $modalBody = $(modal).find(modalBody);

      $modal.attr({
        'aria-modal': 'true'
      });



      // iframeの'src'を'data-src'から復元
      $modal.find('iframe[data-src]').each(function () {
        const $iframe = $(this);
        if (!$iframe.attr('src')) {
          $iframe.attr('src', $iframe.data('src'));
        }
      })

      // モーダルを表示させる
      $modal.fadeIn(200).addClass('active');
      $modalBody.fadeIn(250).addClass('active');
      lastFocusedEl = document.activeElement;
      $modal.find('.m_modal_close-btn').focus();

    });

    // モーダルを非表示にする
    $(modal).on('click', function () {
      $(modalBody).removeClass('active').css('display', 'none').removeClass('active').attr('aria-modal', 'false');
      $(modal).fadeOut(250).removeClass('active');

      $(modal).find('iframe').each(function () {
        $(this).attr('src', '');
      });

      if (lastFocusedEl) {
        lastFocusedEl.focus();
      }
    });

    $(modal).on('keydown', function (e) {

      if (e.key === 'Escape') {
        e.preventDefault();

        $('.js-OpenModal').removeClass('active').css('display', 'none').attr('aria-modal', 'false');

        if (lastFocusedEl) {
          lastFocusedEl.focus();
        }
      }
    });
  }

  // ----------------------------------------
  //  gsap
  // ----------------------------------------

  gsap.config({
    nullTargetWarn: false,
  });

  gsap.registerPlugin(ScrollTrigger);

  gsap.utils.toArray(".fade-in").forEach((el) => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,        // それぞれの要素がトリガーになる
        start: "top 60%",
      }
    });

    tl.from(el, { opacity: 0, duration: 0.8, delay: .2, ease: "power4.out", y: 50 })

  });

  gsap.utils.toArray(".fade-in_pic").forEach((el) => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,        // それぞれの要素がトリガーになる
        start: "top 60%",
      }
    });

    tl.from(el, { opacity: 0, duration: 0.3, })
      .from(el.querySelector(".fade-in_2"), { opacity: 0, duration: 0.4, ease: "power4.out", y: 50 }, "+=0.1")
      .from(el.querySelector(".fade-in_pic2"), { opacity: 0, duration: 0.3, ease: "power2.ease" }, "-=0.2")
      .from(el.querySelector(".fade-in_pic4"), { opacity: 0, duration: 0.3, ease: "power2.ease" }, "-=0.1")
      .from(el.querySelector(".fade-in_pic1"), { opacity: 0, duration: 0.3, ease: "power2.ease" }, "-=0.2")
      .from(el.querySelector(".fade-in_pic3"), { opacity: 0, duration: 0.3, ease: "power2.ease" }, "-=0.15")
      .from(el.querySelector(".fade-in_5"), { opacity: 0, duration: 0.3, ease: "power4.out", y: 50 }, "+=0.2");


  });

  gsap.utils.toArray(".fade-in_1").forEach((el) => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,        // それぞれの要素がトリガーになる
        start: "top 60%",
      }
    });
    const pic = el.querySelector(".fade-in_pic");
    const top = document.querySelector(".top");
    const karakuriAndNazenani = document.querySelector(".karakuri .m_container") || document.querySelector(".nazenani .m_container") || document.querySelector(".nazenani_contents");

    if (top) {
      tl.from(el, { opacity: 0, duration: 0.3, delay: .2 })
        .from(el.querySelector(".fade-in_2"), { opacity: 0, duration: 0.4, ease: "power4.out", y: 50 }, "-=0.1")
        .from(el.querySelector(".fade-in_3"), { opacity: 0, duration: 0.3, ease: "power4.out", y: 50 }, "-=0.1")
        .from(el.querySelector(".fade-in_4"), { opacity: 0, duration: 0.3, ease: "power4.out", y: 50 }, "-=0.1")
        .from(el.querySelector(".fade-in_5"), { opacity: 0, duration: 0.3, ease: "power4.out", y: 50 }, "-=0.1")
        .from(el.querySelector(".fade-in_slide"), { opacity: 0, duration: 1.2, ease: "power4.out", xPercent: 120 }, "-=0.1")
        .from(el.querySelector(".fade-in_6"), { opacity: 0, duration: .5, ease: "power4.out", y: 50 }, "+=0.1")
        .from(el.querySelector(".fade-in_7"), { opacity: 0, duration: .5, ease: "power4.out", y: 50 }, "-=0.1");
    } else if (karakuriAndNazenani) {
      tl.from(el, { opacity: 0, duration: 0.3, delay: .2, ease: "power4.out", y: 50 })
        .from(el.querySelector(".fade-in_2"), { opacity: 0, duration: 0.6, ease: "power4.out", y: 50 }, "-=0.1")
        .from(el.querySelector(".fade-in_3"), { opacity: 0, duration: 0.4, ease: "power4.out", y: 20 }, "-=0.2")
        .from(el.querySelector(".fade-in_4"), { opacity: 0, duration: 0.4, ease: "power4.out", y: 20 }, "-=0.1")
        .from(el.querySelector(".fade-in_5"), { opacity: 0, duration: 0.4, ease: "power4.out", y: 20 }, "-=0.1");
    } else if (pic) {
      tl.from(el, { opacity: 0, duration: 0.3, delay: .2 })
        .from(el.querySelector(".fade-in_2"), { opacity: 0, duration: 0.4, ease: "power4.out", y: 50 }, "-=0.5")
        .from(el.querySelector(".fade-in_3"), { opacity: 0, duration: 0.3, ease: "power4.out", y: 50 }, "-=0.1")
        .from(el.querySelector(".fade-in_4"), { opacity: 0, duration: 0.3, ease: "power4.out", y: 50 }, "-=0.1")
        .from(el.querySelector(".fade-in_pic2"), { opacity: 0, duration: 0.1, ease: "power4.out" }, "+=0.2")
        .from(el.querySelector(".fade-in_pic4"), { opacity: 0, duration: 0.1, ease: "power4.out" }, "+=0.2")
        .from(el.querySelector(".fade-in_pic1"), { opacity: 0, duration: 0.1, ease: "power4.out" }, "+=0.15")
        .from(el.querySelector(".fade-in_pic3"), { opacity: 0, duration: 0.1, ease: "power4.out" }, "+=0.1")
        .from(el.querySelector(".fade-in_5"), { opacity: 0, duration: 0.3, ease: "power4.out", y: 50 }, "+=0.2");

    }

  });

  gsap.utils.toArray(".purpose_video-box").forEach((el) => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,        // それぞれの要素がトリガーになる
        start: "top 60%",
      }
    });

    tl.from(el, { opacity: 0, duration: 0.8, delay: .2, ease: "power4.out", y: 50 })

  });

});

